// extracted by mini-css-extract-plugin
export default {"navContainer":"nav_navContainer__4lUAa","selected":"nav_selected__qeB9I","desktopNav":"nav_desktopNav__U-Mvw","selectNav":"nav_selectNav__yEMih"};